const doc = [({"ko":({"adminConstantLanguageType":({"en":"영어", "ja":"日本语", "ko":"한국어", "zhCn":"중국어 (중국어 간체)", "zhTw":"중국어 (번체)"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;